import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';

import useEvents from 'lib/hooks/useEvents';
import ExpandCollapseTap from 'lib/Tracking/Srp/SearchFilters/ExpandCollapseTap';
import { Features } from 'lib/EventSchema';

import SrpEventContext from 'contexts/SrpEventContext';
import Accordion from 'components/Shared/SearchFilter/Accordion';
import { BedTypeFacet } from 'lib/AutolistAPI';
import { CabinFacet, RearWheelFacet } from 'lib/apis/SearchApi/types';
import FilterAccordionAtom, { FilterAccordionName } from 'atoms/FilterAccordionAtom';
import CabinTypeFilter from './CabinTypeFilter';
import RearWheelFilter from './RearWheelFilter';
import BedTypeFilter from './BedTypeFilter';

export default function TruckOptionsFilter({
  cabinFacets,
  bedFacets,
  rearWheelFacets,
}: {
  cabinFacets?: CabinFacet;
  bedFacets?: BedTypeFacet;
  rearWheelFacets?: RearWheelFacet;
}): JSX.Element {
  const logger = useEvents();
  const { sourcePage } = useContext(SrpEventContext);
  const { t } = useTranslation();

  const [filterAccordionAtom, setFilterAccordionAtom] = useAtom(FilterAccordionAtom);
  const filterExpanded = filterAccordionAtom[FilterAccordionName.TruckOptions];

  function handleAccordionClick(): void {
    setFilterAccordionAtom({
      [FilterAccordionName.TruckOptions]: !filterExpanded,
    });
    logger.log(
      ExpandCollapseTap({ feature: Features.bodyStyles, expanded: !filterExpanded, sourcePage })
    );
  }

  return (
    <Accordion
      title={t('srp.filters.truckOptions.header')}
      expanded={filterExpanded}
      onClick={handleAccordionClick}
    >
      <CabinTypeFilter cabinFacets={cabinFacets} />
      <RearWheelFilter rearWheelFacets={rearWheelFacets} />
      <BedTypeFilter bedFacets={bedFacets} />
    </Accordion>
  );
}
